import React, { useMemo } from 'react'
import { useGlobalState } from '@/store'
import { logOut } from '@yuanfudao/metis-unified-login'
import config from '@yuanfudao/metis-unified-login/es/config'
import { ProjectConfig } from '@/project-config'
import { useLocation } from 'react-router-dom'
import lessModule from './index.module.less'

const { logoSrc } = ProjectConfig

export default function Header() {
  const { isLogin, setIsLogin } = useGlobalState()

  const location = useLocation()
  const isLoginPage = useMemo(() => ['/', '/login', '/login/', '/login/bind'].includes(location.pathname), [location])

  const handleLogOut = async () => {
    setIsLogin(false)
    await logOut()
    if (['/open-login', '/nydus', '/nydus-v2'].includes(location.pathname)) {
      window.location.href = config.loginURL
    }
  }

  return (
    <div className={lessModule.headerWrap} style={{ position: `${isLoginPage ? 'relative' : 'fixed'}` }}>
      <div className={`${lessModule.header}`}>
        <img className={lessModule.logo} src={logoSrc} alt="" />
        {
          isLogin && !isLoginPage && (
            <span className={lessModule.logout} onClick={handleLogOut}>退出登录</span>
          )
        }
      </div>
    </div>
  )
}
